import React, { useContext } from 'react';

import { CMSContext } from '@swf/cms';
import type { ProspectHomepageSlide } from '@swf/cms';
import type { ItemBlock } from '@swf/generated/cms/types/Carousel';

import ColumnLayout from './ColumnLayout/ColumnLayout';
import styles from './ProspectHomepageCarousel.scss';
import SliderLayout from './SliderLayout/SliderLayout';

interface Props {
  autoRotate: boolean;
  slides: ItemBlock[];
  slideSpeed: number;
}

const minNumberOfSlides = 2;

const ProspectHomepageCarousel: React.FC<Props> = ({ autoRotate, slides, slideSpeed }) => {
  const cmsContext = useContext(CMSContext);

  if (slides.length < minNumberOfSlides) {
    return null;
  }

  const slidesData = slides.map(
    (s) => cmsContext[s.item.reference[0].uid] as ProspectHomepageSlide
  );

  return (
    <section className={styles.wrapper}>
      <SliderLayout autoRotate={autoRotate} slides={slidesData} slideSpeed={slideSpeed} />
      <ColumnLayout slides={slidesData} />
    </section>
  );
};

export default ProspectHomepageCarousel;
